import React from 'react'
import Testmonials from '../assets/Tesmonials.json'

function Tesmonials() {
  return (
    <div className=' mt-10 text-gray-500'>
      
                <div>
                  <h1 className='text-center text-2xl font-medium font-mono'> my clients...</h1>
                </div>
      <div className='grid grid-cols-1 md:grid-cols-2 mt-10 w-full'>
          {Testmonials.map((client)=>(
            <div key={client.id} className="rounded-3xl shadow-md p-10 gap-2 hover:-translate-y-4
            duration-100 ">
                    
              <div className='flex gap-3' >
                      <img src={client.img} className="rounded-full w-8 h-8" alt="" />
                      <p className='ml-5 space-y-0 text-md text-base font-bold'>
                        <a href={client.link}> { client.name}</a>
                        <p className='text-sm -mt4 font-normal'>
                        {client.nickname}
                      </p>
                      </p>
                      
                      
              </div>

                        <div>
                          <h1>{client.desc}</h1>
                        </div>
                        
             </div>



        
        ))}

      </div>
    </div>
  )
}

export default Tesmonials
